import { Component, Input, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { IUserNotification } from '@serasa/core/modules/notifications/interfaces/notifications.interface';
import * as NotificationsActions from '@serasa/core/modules/notifications/state/notifications.actions';
import { Store } from '@ngrx/store';

@Component({
    selector: 'pl-new-features',
    templateUrl: './new-features.component.html',
    styleUrls: ['./new-features.component.scss'],
    animations: [
        trigger('slideOut', [
            state('visible', style({ transform: 'translateX(0)' })),
            state('hidden', style({ transform: 'translateX(100%)' })),
            transition('visible => hidden', [
                animate('0.5s ease-out')
            ]),
            transition(':enter', [
                animate('0.5s ease-in')
            ])
        ])
    ],
    standalone: false
})
export class NewFeaturesComponent implements OnInit {

  constructor(
    private readonly store: Store
  ) { }

  @Input() not?: IUserNotification;
  public isHidden = false;

  ngOnInit(): void {
      if (this.not) {
        const notificationId = this.not?.userNotificationId;
        this.store.dispatch(NotificationsActions.loadEventTypeLoadNotification({ notificationId }));
      }
  }

  closeNotification() {
    const notificationId = this.not?.userNotificationId || '';
    this.store.dispatch(NotificationsActions.loadEventTypeDismissNotification({ notificationId }));
    this.isHidden = true;
  }

}
